import {
  ApplicationConfig, inject, provideAppInitializer,
  provideBrowserGlobalErrorListeners
} from '@angular/core'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {provideRouter, withHashLocation} from '@angular/router'

import {routes} from './app.routes'
import {Bootstrap} from './services/bootstrap'

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withHashLocation()),
    provideAppInitializer(() => inject(Bootstrap).bootstrap()),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        floatLabel: 'always',
        appearance: 'outline'
      }
    },
  ]
}
